import React from "react";
import {t} from "i18next";
import {InputControl, PasswordInputControl, error} from "./Input";


class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: {
                email: "",
                name: "",
                lastName: "",
                password: "",
            },
            errors: {
                email: "",
                name: "",
                lastName: "",
                password: "",
                common: ""
            },
            isSuccess: false,
            isSubmitted: false
        }

        this.inputValueChanged = this.inputValueChanged.bind(this)
        this.inputFocusLeave = this.inputFocusLeave.bind(this)
    }

    inputFocusLeave(field) {
    }

    validateField(field, value) {
        switch (field) {
            case 'password':
                if (!this.isValidPassword(value))
                    return t('Errors_' + field)
                break;
            default:
                if (!value)
                    return t('Errors_' + field)
        }

        return '';
    }

    inputValueChanged(event) {
        const state = this.state;
        state.userInfo[event.name] = event.value;
        state.errors[event.name] = '';
        this.setState(state);
    }

    isValidPassword(password) {
        return password.length >= 8;
    }

    isEnabledButton() {
        return true;
    }

    onSubmit(event) {
        event.preventDefault();
        this.clearErrors();

        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(this.state.userInfo)
        };
        const state = this.state;
        state.isSubmitted = true;
        this.setState(state);

        fetch(process.env.REACT_APP_SUBMIT_URL, requestOptions)
            .then(response => response.json())
            .then(data => {
                state.isSubmitted = false;
                if (data.success) {
                    this.props.userRegisterSuccessHandler(true, state.userInfo);
                } else {
                    if (data.fatal) {
                        this.props.fatalErrorHandler()
                    } else {
                        state.errors = data.errors;
                    }
                }
                this.setState(state);
            }).catch(() => {
            state.isSubmitted = false;
            state.errors.common = t("Communication")
            this.setState(state);
        })

        return false;
    }

    clearErrors() {
        let state = this.state;
        state.errors = {
            email: "",
            name: "",
            lastName: "",
            password: "",
            common: ""
        };
        this.setState(state)
    }

    render() {
        let button = this.isEnabledButton() && !this.state.isSubmitted ?
            <button className="button" type='submit'>Create an account</button> :
            <button className="button" type='submit' disabled>Create an account</button>
        return (
            <form className="registration" onSubmit={(event) => this.onSubmit(event)}>
                <p className="required">{t("Required fields are indicated with \"*\"")}</p>
                <InputControl
                    name="email"
                    value={this.state.userInfo.email}
                    error={this.state.errors.email}
                    placeholder={t("E-mail")}
                    onChange={this.inputValueChanged}
                    onFocusLeave={this.inputFocusLeave}
                />
                <InputControl
                    name="name"
                    error={this.state.errors.name}
                    value={this.state.userInfo.name}
                    placeholder={t("Name")}
                    onChange={this.inputValueChanged}
                    onFocusLeave={this.inputFocusLeave}
                />
                <InputControl
                    name="lastName"
                    error={this.state.errors.lastName}
                    value={this.state.userInfo.lastName}
                    placeholder={t("Surname")}
                    onChange={this.inputValueChanged}
                    onFocusLeave={this.inputFocusLeave}
                />
                <PasswordInputControl
                    name="password"
                    type="password"
                    error={this.state.errors.password}
                    value={this.state.userInfo.password} placeholder={t("Password")}
                    hint={t("Password length", {count: 8})}
                    onChange={this.inputValueChanged}
                    onFocusLeave={this.inputFocusLeave}
                    requiered
                    minLength='8'
                />
                {button}
            </form>
        )
    }
}

export default RegistrationForm
